import { useState } from 'react'
import Consulta from './consulta'
import NovoVinculo from './consulta/edit/novoVinculo'

const VoxSoftwares = () => {
  const [showNovoVinculo, setShowNovoVinculo] = useState(false)
  const [selectedClienteForVinculo, setSelectedClienteForVinculo] = useState(null)

  const handleNovoVinculo = (cliente = null) => {
    setSelectedClienteForVinculo(cliente)
    setShowNovoVinculo(true)
  }

  const handleCloseVinculo = () => {
    setShowNovoVinculo(false)
    setSelectedClienteForVinculo(null)
  }

  return (
    <div className='w-full min-h-full p-6 bg-gray-50 dark:bg-gray-900'>
      <div className="flex justify-between items-start mb-6">
        <div>
          <h1 className="text-3xl font-semibold text-gray-900 dark:text-white mb-2">
            Gestão de Softwares
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Gerencie vínculos de softwares (Vox Chat e Edutech)
          </p>
        </div>
        <button
          onClick={() => handleNovoVinculo()}
          className="btn-vox-primary flex items-center gap-2"
        >
          <span className="text-lg">+</span>
          Novo Vínculo
        </button>
      </div>
      
      <Consulta onNovoVinculo={handleNovoVinculo} />

      {showNovoVinculo && (
        <NovoVinculo 
          selectedCliente={selectedClienteForVinculo}
          closeModal={handleCloseVinculo}
        />
      )}
    </div>
  )
}

export default VoxSoftwares
